import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "id", "size", "variant", "sx"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import Button from '@mui/material/Button';
export var MuiButton = function (props) {
    var _a = props.name, name = _a === void 0 ? "Button" : _a, _b = props.id, id = _b === void 0 ? name : _b, _c = props.size, size = _c === void 0 ? "small" : _c, _d = props.variant, variant = _d === void 0 ? "outlined" : _d, sx = props.sx, other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(Button, _extends({
        variant: variant,
        size: size,
        id: id
    }, other, {
        sx: _objectSpread({
            borderRadius: '8px',
            textTransform: 'none'
        }, sx)
    }), name);
};
